export default __webpack_public_path__ + "static/media/Money Transfer Integration Test Cases.e2235a13.pdf";